/**
 * BetUDontBet Poker (BUDB PKR) — public product brand SSOT.
 */
export const BRAND = {
  /** Full marketing name */
  name: "BetUDontBet Poker",
  /** Short product code */
  shortName: "BUDB PKR",
  /** Tagline */
  tagline: "Real GBUX Texas Hold'em on Solana",
  /** Host */
  origin: "https://poker.grudge-studio.com",
  /**
   * Asset stream SSOT (served from Worker Static Assets = client/public).
   * Do not invent parallel CDN paths for these — all under poker.grudge-studio.com.
   */
  logo: "/media/budb-pkr-logo-mark.jpg",
  /** Gold monogram mark (from table monogram source images/15 → remade 28) — header, watermark, menu */
  logoMark: "/media/budb-pkr-logo-mark.jpg",
  logoMarkBranding: "/branding/budb-pkr-logo-mark.jpg",
  /** Black-square monogram (app tile / dark chrome) */
  logoMarkBlack: "/media/logo/budb-pkr-mark-black.jpg",
  logoMarkBlackBranding: "/branding/budb-pkr-logo-mark-black.jpg",
  /** Archive: table monogram source (felt art only — not chrome logo) */
  logoSourceTable: "/media/logo/source-table-monogram.jpg",
  icon: "/branding/budb-icon.png",
  appIcon: "/branding/app-icon.png",
  /** Official GBUX coin */
  gbuxCoin: "/media/gbux-logo.png",
  gbuxCoinSm: "/media/gbux-logo-64.png",
  /** Lobby ambient fallback (Craftpix stage uses tableHero) */
  lobbyBg: "/media/brand/budb-table-hero.jpg",
  /**
   * Production key art (2026-08)
   * - pokerSolPro: wide Solana/poker pro plate (landing desktop, transfer load)
   * - tableHero: anime BUDB felt scene (landing mobile, lobby ambient)
   */
  pokerSolPro: "/media/brand/poker-sol-pro.webp",
  tableHero: "/media/brand/budb-table-hero.jpg",
  /** Transfer / fund / connect loading plate */
  transferLoad: "/media/brand/poker-sol-pro.webp",
  ogImage: "/media/brand/poker-sol-pro.webp",
  /** Dealer puck (D button) — table chrome */
  dealerButton: "/media/dealer-button.jpg",
  /** Playing card back — BUDB monogram (logo mark) */
  cardBack: "/media/card-back-budb.jpg",
  cardBackDeck: "/cards2/shirt_budb.jpg",
  /** Landing “Why BUDB” feature container art */
  features: {
    holdem: "/media/features/holdem.jpg",
    web3: "/media/features/web3-gbux.jpg",
    accounts: "/media/features/accounts.jpg",
    install: "/media/features/install.jpg",
    rewards: "/media/features/rewards.jpg",
    aiEdge: "/media/features/ai-edge.jpg",
  },
  felts: {
    green: "/media/felt-budb-green.jpg",
    red: "/media/felt-budb-red.jpg",
    blue: "/media/felt-budb-blue.jpg",
    clean: "/media/felt-green-clean.jpg",
    verticalPhone: "/media/felt-vertical-phone.jpg",
  },
  slots: {
    /** Racalvin the Pirate King — Ethereal Treasure */
    title: "Ethereal Treasure",
    subtitle: "Racalvin · Pirate Kings",
    ambient: "/slots/bg/racalvin-banner.webp",
    ambientAlt: "/slots/bg/ethereal-treasure-keyart.jpg",
    logo: "/slots/racalvin/pirate-logo.png",
    introVideo: "/slots/video/intro-racalvin.mp4",
    progressiveVideo: "/slots/video/progressive-sea.mp4",
    /** Racalvin mesh shell — large glass + deck plates for HUD (AI mesh) */
    cabinet: "/slots/gen/cabinet-mesh.jpg",
    cabinetLore: "/slots/gen/cabinet-mesh.jpg",
    cabinetLegacy: "/slots/gen/cabinet-racalvin.jpg",
    /** Transparent PNG pull lever (no plate background) */
    lever: "/slots/gen/lever-red.png",
    spinBtn: "/slots/gen/spin-btn.jpg",
    winMarquee: "/slots/gen/win-marquee.jpg",
    craftSpin: "/slots/craftpix/buttons/Spin1.png",
    craftFrame: "/slots/craftpix/frames/Frame01.png",
    craftPanel: "/slots/craftpix/buttons/panel.png",
    fxBigWin: "/slots/fx/big-win-v5.jpg",
    fxJackpot: "/slots/fx/jackpot.jpg",
    fxBonus: "/slots/fx/bonus-portal.jpg",
    fxFreeSpins: "/slots/fx/free-spins.jpg",
    /** 5×5 Ethereal Treasure generation pack */
    iconsV5: "/slots/icons/v5",
    grid: { reels: 5, rows: 5, maxLines: 25 },
    lore:
      "Sail the ethereal seas under Racalvin, Pirate King of the Ghost Fleet. Grudge's Most Wanted Rewards · Lord Malachar free-spin bounty · 5×5 · 25 paylines.",
    mostWanted: {
      label: "Grudge's Most Wanted Rewards",
      freeSpinBounty: "Lord Malachar · Minion Bounty",
      icons: "/slots/bounty",
    },
  },
  account: {
    bg: "/media/account/account-bg.jpg",
    badge: "/media/account/account-badge.jpg",
  },
  /**
   * Poker chrome plates (Imgur mirrored → Worker Static Assets).
   * - feltPattern: page / stage backgrounds (suit motif) — was flat purple/navy
   * - wood: containers / panels / stat tiles — was solid zinc/purple
   * Do not hotlink Imgur in production; paths are same-origin only.
   */
  panels: {
    /** Green suit motif — backgrounds (source: i.imgur.com/mPWfib6.png) */
    feltPattern: "/media/poker/panel-felt-pattern.webp",
    feltPatternJpg: "/branding/panel-felt-pattern.jpg",
    /** Warm wood grain — containers (source: i.imgur.com/nOMtP1t.png) */
    wood: "/media/poker/panel-wood.webp",
    woodJpg: "/branding/panel-wood.jpg",
  },
} as const;

export function feltForTheme(
  theme: "green" | "red" | "violet" | "blue",
): string {
  if (theme === "red") return BRAND.felts.red;
  if (theme === "violet" || theme === "blue") return BRAND.felts.blue;
  return BRAND.felts.green;
}
